import EventSaleService from '@/services/EventSale'

export const state = () => ({
})

export const mutations = {
}

export const actions = {
  getOngoingSaleSessions ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      EventSaleService.getOngoingSession(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload
      )
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  getEventSaleProducts ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      EventSaleService.getEventSaleProducts(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload
      )
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}
